import { fontFamilies } from './fonts'
import colors from './colors'

export default {
  mainTextContainer: {
    // ...fontFamilies.comfortaa,
    maxWidth: 800,
    padding: 10,
    // TODO: sort this out. 90% is a hack
    width: '90%',
    margin: '0 auto',
    alignSelf: 'stretch',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  link: {
    color: colors.darkBlue,
    textDecoration: 'none',
    fontFamily: 'Josefin Sans',
    cursor: 'pointer',
    display: 'inline-block',
    fontWeight: 'light',
    ':hover': {
      color: colors.darkBlue,
      textDecoration: 'none',
      borderBottom: `1px solid ${colors.darkBlue}`,
    },
    ':active': {
      color: colors.darkBlue,
      textDecoration: 'none',
      borderBottom: `1px solid ${colors.darkBlue}`,
    },
    ':focus': {
      color: colors.darkBlue,
      textDecoration: 'none',
      borderBottom: `1px solid ${colors.darkBlue}`,
    },
  }
}


// WEBPACK FOOTER //
// ./src/themes/applicationStyles.js